import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name?.split(" ")[0]}!`);
      navigate(user.role === "admin" ? "/admin" : from);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid grid-cols-1 md:grid-cols-2 gap-0" data-testid="login-page">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1701421016474-09b19faa9f77?w=1600&q=80" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 scrim-bottom" />
        <div className="absolute bottom-10 left-10 text-white max-w-xs">
          <p className="font-serif-display text-3xl leading-tight">Welcome back to your next stay.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[hsl(10_51%_55%)]">Sign in</p>
            <h1 className="font-serif-display text-3xl mt-2">Hello again</h1>
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="mt-2" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="mt-2" />
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-forest rounded-full h-11" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-sm text-center text-[hsl(100_3%_30%)]">
            New here? <Link to="/register" className="text-[hsl(10_51%_55%)] font-medium" data-testid="link-to-register">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
